import { DraggableLocation } from "@hello-pangea/dnd";
import { VerticalSpacer } from "components/Layout";
import { Section } from "components/content/Section";
import { IDraggableAlignmentResultSection, ISectionGroup, SectionGroup } from "store/types";

interface IProps {
  state: any;
  onMoveResourceViaMenu: (source: DraggableLocation, destination: DraggableLocation, draggableId: string[]) => any;
  onExcludeResourceViaMenu: (source: DraggableLocation, draggableId: string[]) => any;
}

export const Sorted = ({ state, onMoveResourceViaMenu, onExcludeResourceViaMenu }: IProps) => {
  const sectionGroup =
    state &&
    state.sectionGroups &&
    state.sectionGroups.find((sectionGroup: ISectionGroup) => sectionGroup.name === SectionGroup.SORTED);
  if (sectionGroup) {
    return (
      <>
        {sectionGroup.sections.map((section: IDraggableAlignmentResultSection, index: number) => {
          const resources = section.resourceIds.map((uid: any) =>
            state.resources.find((resource: any) => resource.uid === uid),
          );
          return (
            <div key={section.uid}>
              <VerticalSpacer height="16px" />
              <Section
                key={section.uid}
                state={state}
                section={section}
                resources={resources}
                onMoveResourceViaMenu={onMoveResourceViaMenu}
                onExcludeResourceViaMenu={onExcludeResourceViaMenu}
                expand={index === 0}
                sidebar={false}
                shortcut={index === 0 ? ["s", "S"] : undefined}
              />
            </div>
          );
        })}
      </>
    );
  } else {
    return null;
  }
};
